module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/_british-antarctic-territory-5ce52a99b520d2549497a2bd04b4fd2e.png";